import React, {Component} from 'react'
import Dom from '../../helpers/Dom';    
import  './newMapBucket.css'
import { connect } from 'react-redux';
import actions from '../../store/actions';
import Car_lock from '../../../src/assets/svg/Car_lock.svg';
import Car_unlock from '../../../src/assets/svg/Car_unlock.svg';

class NewInMapBucket extends Component {
    constructor(props) {
        super(props)
        this.state = {
            lock: false,
            unlock: false
        }
        window.closeNewbuckets = () => {
            this.setState({lock: false, unlock: false})
        }
        this.getStatsConfig = () => {
            let stats = [];
            for (let idx in this.props.statsConfig) {
                if (!this.props.statsConfig[idx].parent) {
                    this.props.statsConfig[idx].children = [];
                    stats.push(this.props.statsConfig[idx])
                }
            }
    
            for (let idx in this.props.statsConfig) {
                if (this.props.statsConfig[idx].parent) {
                    for (let jdx in stats) {
                        if (stats[jdx].key === this.props.statsConfig[idx].parent) {
                            stats[jdx].children.push(this.props.statsConfig[idx]);
                        }
                    }
                }
            }
            return stats;
        }
        this.getStats = (item) => {

            if(this.props.searchResult != null && this.props.searchString !== ""){
                return Object.values(this.props.searchResult).filter(v => {
                    if(v.filters.includes(item.key)){
                        return true
                    }
                }).length
            }
            const checkpath = window.localStorage.getItem("checkpath");
            if(checkpath && this.props.statsFilter) {
                const groups = JSON.parse(checkpath);
                const gpaths = groups.map(g => g.path);
                let key = this.props.statsFilter.key
                return Object.values(this.props.vehicleMap).filter(v => {
                    if(v.filters.includes(item.key) && v.filters.includes(key)) {
                        const gs = v.groups.map(g => g.path)
                        for(let g of gpaths) {
                            if(gs.includes(g)) return true;
                        }
                    }
                }).length
            } 
           
            return this.props.stats && this.props.stats[item.key] != null ? this.props.stats[item.key] : 0;
        };
        this.applyStatFilter = (item) => {
            let vehicleList=[]
            let key = this.props.statsFilter.key
            this.setState({
                vehicleList:[],
                showPopup: true,
                clickedCatogory: item.key

            })
            
            Object.values(props.vehicleMap).filter(v => {
                if(v.filters.includes(item.key)) {
                    vehicleList.push(v)
                }})
                this.setState({
                    vehicleList:  vehicleList
                })            
                
                this.props.dispatch({
                    type: actions.LOCK_BUTTON,
                    data: {
                        key : item.key,
                        clicked: true
                    }
                  });  
              this.props.dispatch({
                type: actions.SOC_SORTED,
                data: vehicleList
              });
              this.props.dispatch({
                type: actions.TOGGLE_LEFT_TREE,
                data: 4
              });
              
        };
        this.isItemActive = (key) => {
            if(this.state.clickedCatogory === key){
                return true
            }else {
                false
            }
        }
    }
    render () {
        return (
            <div className='newInMapBucket'>
                <div className={this.state.lock ? "lockswitch_slide" : "lockswitch"}>
                <div className="bucket-name"><span>Lock</span></div>
                {
                    this.getStatsConfig().map((item, index) => {
                        if(item.type == "lock"){
                            return (
                                <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                    <div style={{color:item.clr}}>{item.name}</div>
                                    <div>{this.getStats(item)}</div>
                                </div>
                            )
                        }
                    })
                }
            </div> 
            <div className="buckets" onClick={() => {this.setState({lock: !this.state.lock, unlock:false}); window.closeBuckets()}}>
                <div className="bucketicon" >
                    <img src={Car_lock}/>
                </div>
            </div>
            <div className={this.state.unlock ? "unlockswitch_slide" : "unlockswitch"}>
                <div className="bucket-name"><span>Unlock</span></div>
                {
                    this.getStatsConfig().map((item, index) => {
                        if(item.type == "unlock"){
                            return (
                                <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                    <div style={{color:item.clr}}>{item.name}</div>
                                    <div>{this.getStats(item)}</div>
                                </div>
                            )
                        }
                    })
                }
            </div> 
            <div className="unlock_bucket" onClick={() => {this.setState({unlock: !this.state.unlock,lock:false}); window.closeBuckets()}}>
                <div className="bucketicon" >
                    <img src={Car_unlock}/>
                </div>
            </div>
            </div>
          )
    }
  
}

const MapPropsToState = (state) => {
    return {
        auth: state.auth,
        stats: state.stats,
        roadStats: state.roadStats,
        reportWindow: state.reportWindow,
        statsFilter: state.statsFilter,
        gotAllBuckets: state.gotAllBuckets,
        vehicleMap: state.vehicleMap,
        userInfo: state.userInfo,
        userType: state.userType,
        multiSearchConditions: state.multiSearchConditions,
        searchResult: state.searchResult,
        searchString: state.searchString,
    }
};

 export default connect(MapPropsToState)(NewInMapBucket);